import { useMemo } from 'react';
import { useQuery } from '@hotjar/webapp/utils/routing';

export const useResponseId = (): number | undefined => {
  const query = useQuery();

  return useMemo(() => {
    const queryResponseId = query.get('prid');

    if (queryResponseId === null) return undefined;

    return Number(queryResponseId);
  }, [query]);
};
